/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import _ from 'lodash';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { Button } from 'react-bootstrap';

// custom imports
import CustomSeparator from '../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import {
  redirectURLLink,
  upperCaseFirstLetter,
  lowerCaseAllWordsExceptFirstLetters,
} from '../../../SharedModules/CommonUtilities/commonUtilities';
import {
  onCellFocused,
  navigateToNextCell,
  tabToNextCell,
} from '../../../SharedModules/AgGridUtilities/suppressNavigation';
import { tabHighLigther } from '../../../SharedModules/utilities/utilities';
import DisplayErrorMessages from '../../../SharedModules/Errors/ErrorMessages';
import * as constantMessageData from '../../../SharedModules/Errors/constantMessageData';
import SearchTypeComponent from '../../../SharedModules/SearchTypeComponent/SearchTypeComponent';
import Spinner from '../../../SharedModules/Spinner/SpinnerNew';

import TableGridWithFeatures from '../../../SharedModules/Table/TableGridWithFeatures';
import SVGComponent from '../../../SharedModules/SVGComponents/SVGComponents';
import RadioGroupComponent from '../../../SharedModules/RadioGroup/RadioGroupBtn';
import {
  NDCTableHead,
  manufacturersTableHead,
} from './gridComponents/tableHead';
import {
  getNDCDetails,
  setNDCErrorPopupMessage,
  setNDCDetails,
  setCurrentNDCDetailsIndex,
  setCurrentNDCDetailsSelected,
} from '../../Display/NDC/store/action';

import {
  selectionList,
  setMfgSelected,
  getAllManufacturerList,
  SearchScreenRedux,
  selectByList,
  searchTypeList,
  getExistingRows,
  handleErrorMessages,
  getNDCByMfgId,
  getUnitConversionDetail,
  dispatchStatusBit,
  getNdcGrid,
  dispatchNdcGrid,
  dispatchGetNDCByMfgId,
  dispatchSuccessMessage,
  dispatchFirstTimeAdd,
  dispatchBottonState,
  setCMSUnitType,
} from './store/actions';
import UnitConversion1st from './index';
import CommonModal from '../../../SharedModules/Dialog/CommonModal';

const UnitConversion = () => {
  const history = useHistory();
  const setSearchUnitConversion = (value) => dispatch(SearchScreenRedux(value));
  const dispatch = useDispatch();

  const mfgSelected = useSelector(
    (state) => state.sharedState?.CMSDrugFileReducer?.mfgSelected
  );
  const statusBit = useSelector(
    (state) => state?.sharedState?.UnitConversionReducer?.statusBit
  );
  const selectByList1 = useSelector(
    (state) => state?.sharedState?.UnitConversionReducer?.selectByList
  );
  const existingRowDataFromAPI = useSelector(
    (state) => state?.sharedState?.UnitConversionReducer?.existingRows
  );
  const selectList = useSelector(
    (state) => state?.sharedState?.UnitConversionReducer?.selectList
  );
  const getReduxValue = useSelector(
    (state) => state?.sharedState?.UnitConversionReducer?.getReduxValue
  );
  const getExitingRow = useSelector(
    (state) => state?.sharedState?.UnitConversionReducer?.getExitingRow
  );
  const searchList = useSelector(
    (state) => state?.sharedState?.UnitConversionReducer?.searchTypeList
  );
  const spinnerLoader = useSelector((state) => {
    return state?.sharedState.showPreLoader?.showPreLoader;
  });
  const getSingleHeaderDataFromRedux = useSelector(
    (state) => state?.sharedState?.UnitConversionReducer?.getSingleNdcByMfgId
  );
  const errorMessagesFromRedux = useSelector(
    (state) => state?.sharedState?.UnitConversionReducer?.errorMessagesInRedux
  );

  const searchCompObj = getReduxValue?.state?.searchTypeState;
  const userDefaults = useSelector(
    (state) => state?.sharedState?.UserDefaultReducer?.UserDefaultsValues?.data
  );
  const manufacturerDataFromAPI = useSelector(
    (state) => state?.sharedState?.UnitConversionReducer?.allManufacturer
  );

  const [selectManufacturer, setSelectManufacturer] = useState(
    mfgSelected || {}
  );
  const [fullScreenView, setFullScreenView] = useState(false);
  const [labelerFullScreen, setLabelerFullScreen] = useState(
    searchCompObj?.labelerFullScreenRedux
      ? searchCompObj?.labelerFullScreenRedux
      : false
  );
  const [ndcLeftFullScreen, setNdcLeftFullScreen] = useState(
    searchCompObj?.ndcLeftFullScreenRedux
      ? searchCompObj?.ndcLeftFullScreenRedux
      : false
  );
  const [ndcRightFullScreen, setNdcRightFullScreen] = useState(
    searchCompObj ? searchCompObj.ndcRightFullScreenRedux : false
  );
  const [labelerSelectedRow, setlabelerSelectedRow] = useState(
    searchCompObj?.labelerSelectedRowRedux
      ? searchCompObj?.labelerSelectedRowRedux
      : ''
  );
  const [ndcLeftSelectedRows, setNdcLeftSelectedRows] = useState(
    searchCompObj?.ndcLeftSelectedRowsRedux
      ? searchCompObj?.ndcLeftSelectedRowsRedux
      : []
  );

  const [ndcRightSelectedRows, setNdcRightSelectedRows] = useState(
    searchCompObj?.ndcRightSelectedRowsRedux
      ? searchCompObj?.ndcRightSelectedRowsRedux
      : []
  );
  const [labelerTableData, setlabelerTableData] = useState(
    searchCompObj?.labelerTableDataRedux
      ? searchCompObj?.labelerTableDataRedux
      : []
  );
  const [ndcLeftTableData, setNdcLeftTableData] = useState(
    searchCompObj?.ndcLeftTableDataRedux
      ? searchCompObj?.ndcLeftTableDataRedux
      : []
  );
  const [ndcRightTableData, setNdcRightTableData] = useState(
    searchCompObj?.ndcRightTableDataRedux
      ? searchCompObj?.ndcRightTableDataRedux
      : []
  );
  const [confirmAction, setConfirmAction] = React.useState(false);
  const [ndcList, setNdcList] = React.useState();
  const gridRef = React.useRef();
  const [gridParams, setGridParams] = useState('');
  const [ndcSearchVal, setNdcSearchVal] = useState(
    searchCompObj?.ndcSearchTextRedux ? searchCompObj?.ndcSearchTextRedux : ''
  );

  const [ndcNameSearchVal, setNdcNameSearchVal] = useState(
    searchCompObj?.ndcNameSearchTextRedux
      ? searchCompObj?.ndcNameSearchTextRedux
      : ''
  );
  const errorMessagesOfSearchTypeComp =
    errorMessagesFromRedux?.searchScreenErrors?.length > 0
      ? _.filter(
          errorMessagesFromRedux?.searchScreenErrors,
          (l) => l?.errorComponent === 'searchTypeComponent' && l.message
        ).map((val) => val)
      : [];

  const [searchType, setSearchType] = useState(
    searchCompObj?.valueSelectedRedux
      ? searchCompObj?.valueSelectedRedux
      : userDefaults?.defNdcSelectModeCd
      ? userDefaults?.defNdcSelectModeCd === 'NDC'
        ? 'NDC'
        : upperCaseFirstLetter(
            lowerCaseAllWordsExceptFirstLetters(
              userDefaults?.defNdcSelectModeCd
            )
          )
      : 'NDC'
  );
  const [errorMsgFromSearchType, setErrorMsgFromSearchType] = useState(
    errorMessagesOfSearchTypeComp
  );
  const [selectContact, setSelectContact] = React.useState(null);
  const [gridApi, setGridApi] = React.useState(null);
  const [arr, setArr] = React.useState([]);
  const [arr2, setArr2] = React.useState([]);
  const [state, setState] = useState(
    getReduxValue?.state
      ? getReduxValue.state
      : {
          selectTypeCd: 'Ad',
          selectByCd: 'Mn',
          allmanufacturercd: true,
          openConversionsCd: true,
          searchTypeState: {
            valueSelectedRedux: 'NDC',
            ndcSearchTextRedux: '',
            ndcNameSearchTextRedux: '',
            ndcLeftTableDataRedux: [],
            ndcRightTableDataRedux: [],
            labelerTableDataRedux: [],
            ndcLeftSelectedRowsRedux: [],
            ndcRightSelectedRowsRedux: [],
            labelerSelectedRowRedux: '',
            ndcLeftFullScreenRedux: false,
            ndcRightFullScreenRedux: false,
            labelerFullScreenRedux: false,
          },
        }
  );
  // handing refresh functionality
  React.useEffect(() => {
    const searchObj = {
      valueSelectedRedux: searchType || 'NDC',
      ndcSearchTextRedux: ndcSearchVal || '',
      ndcNameSearchTextRedux: ndcNameSearchVal || '',
      ndcLeftTableDataRedux: ndcLeftTableData || [],
      ndcRightTableDataRedux: ndcRightTableData || [],
      labelerTableDataRedux: labelerTableData || [],
      ndcLeftSelectedRowsRedux: ndcLeftSelectedRows || [],
      ndcRightSelectedRowsRedux: ndcRightSelectedRows || [],
      labelerSelectedRowRedux: labelerSelectedRow || '',
      labelerFullScreenRedux: labelerFullScreen,
      ndcLeftFullScreenRedux: ndcLeftFullScreen,
      ndcRightFullScreenRedux: ndcRightFullScreen,
    };
    setState({ ...state, searchTypeState: searchObj });
    setSearchUnitConversion({
      fullScreenView: fullScreenView,
      state: { ...state, searchTypeState: searchObj },
    });
  }, [
    searchType,
    labelerSelectedRow,
    ndcLeftSelectedRows,
    ndcRightSelectedRows,
    labelerTableData,
    ndcLeftTableData,
    ndcRightTableData,
    ndcSearchVal,
    ndcNameSearchVal,
    labelerFullScreen,
    ndcLeftFullScreen,
    ndcRightFullScreen,
  ]);
  // handing full screen view
  React.useEffect(() => {
    if (labelerFullScreen || ndcLeftFullScreen || ndcRightFullScreen) {
      setFullScreenView(true);
      const searchObj = {
        valueSelectedRedux: searchType || 'NDC',
        ndcSearchTextRedux: ndcSearchVal || '',
        ndcNameSearchTextRedux: ndcNameSearchVal || '',
        ndcLeftTableDataRedux: ndcLeftTableData || [],
        ndcRightTableDataRedux: ndcRightTableData || [],
        labelerTableDataRedux: labelerTableData || [],
        ndcLeftSelectedRowsRedux: ndcLeftSelectedRows || [],
        ndcRightSelectedRowsRedux: ndcRightSelectedRows || [],
        labelerSelectedRowRedux: labelerSelectedRow || '',
        labelerFullScreenRedux: labelerFullScreen,
        ndcLeftFullScreenRedux: ndcLeftFullScreen,
        ndcRightFullScreenRedux: ndcRightFullScreen,
      };

      setSearchUnitConversion({
        fullScreenView: true,
        state: { ...state, searchTypeState: searchObj },
      });
    } else {
      setFullScreenView(false);
      setSearchUnitConversion({
        fullScreenView: false,
        state: state,
      });
    }
  }, [labelerFullScreen, ndcLeftFullScreen, ndcRightFullScreen]);

  const getErrorsFromSearchTypeComponent = (errors) => {
    if (errors.length > 0) {
      let alreadyPresentErrors = errorMessagesFromRedux?.searchScreenErrors
        ? errorMessagesFromRedux?.searchScreenErrors
        : [];

      setErrorMsgFromSearchType(errors);
      alreadyPresentErrors = alreadyPresentErrors.filter(
        (item) => item?.errorComponent !== 'searchTypeComponent'
      );

      alreadyPresentErrors = alreadyPresentErrors.concat(errors);

      dispatch(
        handleErrorMessages({
          searchScreenErrors: [...new Set(alreadyPresentErrors)],
          detailScreenErrors: errorMessagesFromRedux?.detailScreenErrors
            ? errorMessagesFromRedux?.detailScreenErrors
            : [],
        })
      );
      let getError = errors;
      if (ndcSearchVal.length === 13) {
        getError = errors?.filter(
          (item) => item?.errorType !== 'NDCnotSelected'
        );
      }
      if (getError.length > 0) {
        window.scrollTo(0, 0);
      }

      // window.scrollTo(0, 0);
    } else {
      let alreadyPresentErrors = errorMessagesFromRedux?.searchScreenErrors
        ? errorMessagesFromRedux?.searchScreenErrors
        : [];

      setErrorMsgFromSearchType(errors);
      alreadyPresentErrors = alreadyPresentErrors.filter(
        (item) => item?.errorComponent !== 'searchTypeComponent'
      );

      alreadyPresentErrors = alreadyPresentErrors.concat(errors);

      dispatch(
        handleErrorMessages({
          searchScreenErrors: [...new Set(alreadyPresentErrors)],
          detailScreenErrors: errorMessagesFromRedux?.detailScreenErrors
            ? errorMessagesFromRedux?.detailScreenErrors
            : [],
        })
      );
    }
  };

  const filterAction = (type, val) => {
    let errorMsgWithoutSearch = errorMessagesFromRedux?.searchScreenErrors
      ? errorMessagesFromRedux?.searchScreenErrors
      : [];
    errorMsgWithoutSearch = errorMsgWithoutSearch.filter(
      (item) => item?.errorComponent !== 'searchTypeComponent'
    );
    errorMsgWithoutSearch = errorMsgWithoutSearch.filter(
      (item) => item?.field !== 'search'
    );
    errorMsgWithoutSearch = errorMsgWithoutSearch.filter(
      (item) => item?.errorType !== 'noResults'
    );

    setErrorMsgFromSearchType([]);
    dispatch(
      handleErrorMessages({
        searchScreenErrors: [...new Set(errorMsgWithoutSearch)],
        detailScreenErrors: errorMessagesFromRedux?.detailScreenErrors
          ? errorMessagesFromRedux?.detailScreenErrors
          : [],
      })
    );
    if (type === 'selectTypeCd') {
      setState({ ...state, [type]: val });
      setSearchUnitConversion({
        fullScreenView: fullScreenView,
        state: { ...state, [type]: val },
      });
    }
    if (type === 'selectByCd') {
      setState({
        ...state,
        [type]: val,
        searchTypeState: {
          valueSelectedRedux: 'NDC',
          ndcSearchTextRedux: '',
          ndcNameSearchTextRedux: '',
          ndcLeftTableDataRedux: [],
          ndcRightTableDataRedux: [],
          labelerTableDataRedux: [],
          ndcLeftSelectedRowsRedux: [],
          ndcRightSelectedRowsRedux: [],
          labelerSelectedRowRedux: '',
          ndcLeftFullScreenRedux: false,
          ndcRightFullScreenRedux: false,
          labelerFullScreenRedux: false,
        },
      });

      setSearchType(
        userDefaults?.defNdcSelectModeCd
          ? userDefaults?.defNdcSelectModeCd === 'NDC'
            ? 'NDC'
            : upperCaseFirstLetter(
                lowerCaseAllWordsExceptFirstLetters(
                  userDefaults?.defNdcSelectModeCd
                )
              )
          : 'NDC'
      );
      setNdcLeftSelectedRows([]);
      setlabelerSelectedRow('');

      setNdcRightSelectedRows([]);
      setlabelerTableData([]);
      setNdcLeftTableData([]);
      setNdcRightTableData([]);
      setNdcSearchVal('');
      setNdcNameSearchVal('');
      setSearchUnitConversion({
        fullScreenView: fullScreenView,
        state: {
          ...state,
          searchTypeState: {
            valueSelectedRedux: 'NDC',
            ndcSearchTextRedux: '',
            ndcNameSearchTextRedux: '',
            ndcLeftTableDataRedux: [],
            ndcRightTableDataRedux: [],
            labelerTableDataRedux: [],
            ndcLeftSelectedRowsRedux: [],
            ndcRightSelectedRowsRedux: [],
            labelerSelectedRowRedux: '',
            ndcLeftFullScreenRedux: false,
            ndcRightFullScreenRedux: false,
            labelerFullScreenRedux: false,
          },
        },
      });
      let errorMsgWithoutSearch = errorMessagesFromRedux?.searchScreenErrors
        ? errorMessagesFromRedux?.searchScreenErrors
        : [];
      errorMsgWithoutSearch = errorMsgWithoutSearch.filter(
        (item) => item?.errorComponent !== 'searchTypeComponent'
      );
      errorMsgWithoutSearch = errorMsgWithoutSearch.filter(
        (item) => item?.errorType !== 'noResults'
      );
      setErrorMsgFromSearchType([]);
      dispatch(
        handleErrorMessages({
          searchScreenErrors: [...new Set(errorMsgWithoutSearch)],
          detailScreenErrors: errorMessagesFromRedux?.detailScreenErrors
            ? errorMessagesFromRedux?.detailScreenErrors
            : [],
        })
      );
    }
    if (type === 'allmanufacturercd') {
      setState({ ...state, [type]: val });
      setSearchUnitConversion({
        fullScreenView: fullScreenView,
        state: { ...state, [type]: val },
      });
    }
    if (type === 'openConversionsCd') {
      setState({ ...state, [type]: val });
      setSearchUnitConversion({
        fullScreenView: fullScreenView,
        state: { ...state, [type]: val },
      });
    }
  };
  // handing full screen view
  const handleFullScreenView = () => {
    setFullScreenView(!fullScreenView);
    setSearchUnitConversion({
      fullScreenView: !fullScreenView,
      state: state,
    });
  };

  const onSelectionChanged = React.useCallback(
    (val) => {
      const selectRow = val.api?.getSelectedRows();

      const arr1 = [];
      selectRow.filter((item) => {
        arr1.push(item.drugSeqNum);
      });

      setSelectContact(selectRow[0]);
      dispatch(selectionList(selectRow[0]));
      setArr(arr1);
    },
    [gridApi]
  );

  const onGridReady1 = (params) => {
    setGridApi(params.api);
    setGridParams(params);
    if (getExistingRow && getExistingRow.length > 0) {
      if (getExitingRow?.drugSeqNum) {
        params.api.forEachNode(
          (node) =>
            node?.data?.drugSeqNum == getExitingRow?.drugSeqNum &&
            node?.setSelected(true)
        );
      } else {
        params.api.forEachNode(
          (node) => node?.rowIndex == 0 && node?.setSelected(true)
        );
      }
    }
    const selectedRowNodes = params.api.getSelectedNodes();
    // onSelectionChanged(selectedRowNodes[0]?.data);
  };

  React.useEffect(() => {
    const arr = [];
    if (ndcRightSelectedRows.length > 0) {
      ndcRightSelectedRows.filter((item) => {
        arr.push(item.drugSeqNum);
      });
    }

    setArr2(arr);
  }, [ndcRightSelectedRows]);

  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  React.useEffect(() => {
    dispatch(selectByList());
  }, []);
  React.useEffect(() => {
    dispatch(searchTypeList());
  }, []);
  React.useEffect(() => {
    if (!state.allmanufacturercd) {
      dispatch(
        getAllManufacturerList({
          showAllInd: true,
          mfgId: '',
        })
      );
    }
  }, [state.allmanufacturercd]);

  React.useEffect(() => {
    if (
      getReduxValue?.state?.selectTypeCd === 'ER' ||
      state?.selectTypeCd === 'ER'
    ) {
      let openConv = true;
      if (getReduxValue?.state?.openConversionsCd || state?.openConversionsCd) {
        openConv = true;
      } else {
        openConv = false;
      }
      dispatch(
        getExistingRows({
          conversionCheck: openConv,
        })
      );
    }
  }, [
    getReduxValue?.state?.selectTypeCd,
    state?.selectTypeCd,
    state?.openConversionsCd,
  ]);

  const getExistingRow = React.useMemo(() => {
    let arrayOfexstingRows;
    if (existingRowDataFromAPI) {
      if (existingRowDataFromAPI.message === 'SUCESS') {
        if (existingRowDataFromAPI.data.length > 0) {
          arrayOfexstingRows = existingRowDataFromAPI.data.map((element) => {
            const obj = {};
            obj.ndc = `${element?.labelerCode}-${element?.productCode}-${element?.packageSize}`;
            obj.drugName = element?.drugName;
            obj.drugSeqNum = element?.drugSeqNum;
            return obj;
          });
        }
      }
    }
    return arrayOfexstingRows;
  }, [existingRowDataFromAPI]);

  const getManufacturerTableData = React.useMemo(() => {
    let arrayOfMfgdata;
    if (manufacturerDataFromAPI) {
      if (manufacturerDataFromAPI.message === 'SUCESS') {
        if (manufacturerDataFromAPI.data.length > 0) {
          arrayOfMfgdata = manufacturerDataFromAPI.data.map((element) => {
            const obj = {};
            obj.manufacturersId = element.mfgId;
            obj.manufacturersName = element.mfgName;
            return obj;
          });
        }
      }
    }
    return arrayOfMfgdata;
  }, [manufacturerDataFromAPI]);

  // handing by default row selection function
  const onGridReady = (params) => {
    if (getManufacturerTableData && getManufacturerTableData?.length > 0) {
      if (mfgSelected?.manufacturersId) {
        params.api.forEachNode(
          (node) =>
            node?.data?.manufacturersId === mfgSelected?.manufacturersId &&
            node?.setSelected(true)
        );
      } else {
        params.api.forEachNode(
          (node) => node?.rowIndex === 0 && node?.setSelected(true)
        );
      }
      const selectedRowNodes = params.api.getSelectedNodes();

      onSelectManufacturer(selectedRowNodes[0]);
    }
  };

  // handing highlight tab
  React.useEffect(() => {
    if (
      errorMessagesFromRedux?.searchScreenErrors &&
      errorMessagesFromRedux?.searchScreenErrors.length > 0
    ) {
      tabHighLigther('/unitConversion', true);
    } else {
      tabHighLigther('/unitConversion', false);
    }
  }, [JSON.stringify(errorMessagesFromRedux)]);

  const callGridApi = async (localErr) => {
    const result = await dispatch(
      getNdcGrid({
        drugSeqNum: getSingleHeaderDataFromRedux?.drugSeqNum,
      })
    );

    if (
      (result.payLoad && result.payLoad.length > 0) ||
      (state.selectTypeCd === 'AN' && state.selectByCd === 'Mn')
    ) {
      // setTimeout(() => {
        redirectURLLink(
          '/unitConversion-detail',
          'Display Unit Conversion for NDC',
          history,
          dispatch
        );
      // });
    } else if (state.selectTypeCd !== 'AN' && state.selectByCd !== 'Mn') {
      localErr.push({
        field: 'search',
        errorType: 'noResults',
        message: constantMessageData.MNFC_NDC_ERROR_MSG,
      });
      dispatch(
        handleErrorMessages({
          searchScreenErrors: [...new Set(localErr)],
          detailScreenErrors: errorMessagesFromRedux?.detailScreenErrors
            ? errorMessagesFromRedux?.detailScreenErrors
            : [],
        })
      );

      window.scrollTo(0, 0);
    }
  };

  React.useEffect(() => {
    let localErr = errorMessagesFromRedux?.searchScreenErrors || [];
    if (
      getSingleHeaderDataFromRedux &&
      Object.keys(getSingleHeaderDataFromRedux).length > 0 &&
      statusBit === 1
    ) {
      if (getSingleHeaderDataFromRedux?.drugSeqNum) {
        localErr = localErr.filter((item) => item.field !== 'search');
        dispatch(
          handleErrorMessages({
            searchScreenErrors: [...new Set(localErr)],
            detailScreenErrors: [],
          })
        );

        callGridApi(localErr);
      }
    } else if (statusBit === 1) {
      localErr = localErr.filter((item) => item.field !== 'search');
      localErr.push({
        field: 'search',
        errorType: 'noResults',
        message: constantMessageData.MNFC_NDC_ERROR_MSG,
      });
      dispatch(
        handleErrorMessages({
          searchScreenErrors: [...new Set(localErr)],
          detailScreenErrors: errorMessagesFromRedux?.detailScreenErrors
            ? errorMessagesFromRedux?.detailScreenErrors
            : [],
        })
      );

      window.scrollTo(0, 0);
    }
  }, [getSingleHeaderDataFromRedux]);
  // Go to NDC details screen
  const goToNdcDetails = async (data) => {
    dispatch(
      handleErrorMessages({
        searchScreenErrors: errorMessagesFromRedux?.searchScreenErrors
          ? errorMessagesFromRedux?.searchScreenErrors
          : [],
        detailScreenErrors: [],
      })
    );
    const response = await getNDCDetails([
      { ndc: data.ndc, drugName: data.drugName },
    ]);
    if (response) {
      dispatch(setNDCErrorPopupMessage(null));
      dispatch(setCurrentNDCDetailsIndex(1));
      dispatch(setCurrentNDCDetailsSelected(response[0], 'All'));
      dispatch(setNDCDetails([{ ndc: data.ndc, drugName: data.ndc }]));
      redirectURLLink('/ndc-details', 'NDC Details', history, dispatch);
    }
  };

  const handleOnClick = async (val, type) => {
    let payLoad;
    dispatch(dispatchGetNDCByMfgId({}));
    dispatch(dispatchNdcGrid([]));
    dispatch(dispatchSuccessMessage({}));
    if (!state.allmanufacturercd && type === 'mfgclick') {
      payLoad = val?.manufacturersId;
    } else if (
      type === 'buttonclick' &&
      arr.length > 0 &&
      state?.selectTypeCd === 'ER'
    ) {
      dispatch(dispatchStatusBit(1));
      dispatch(setCMSUnitType({}));
      await dispatch(
        getUnitConversionDetail({
          drugSeqNum: arr,
        })
      );
    } else if (
      type === 'buttonclick' &&
      arr.length === 0 &&
      state?.selectTypeCd === 'ER'
    ) {
      dispatch(dispatchStatusBit(1));
      let localErr = errorMessagesFromRedux?.searchScreenErrors || [];
      localErr = localErr.filter((item) => item.field !== 'search');
      localErr.push({
        field: 'search',
        errorType: 'noResults',
        message: constantMessageData.ERRORMESSAGE_NDC_WHEN_EMPTY,
      });
      dispatch(
        handleErrorMessages({
          searchScreenErrors: [...new Set(localErr)],
          detailScreenErrors: errorMessagesFromRedux?.detailScreenErrors
            ? errorMessagesFromRedux?.detailScreenErrors
            : [],
        })
      );

      window.scrollTo(0, 0);
    } else if (
      type === 'buttonclick' &&
      state?.selectTypeCd === 'Ad' &&
      state?.selectByCd === 'NDC'
    ) {
      dispatch(dispatchStatusBit(1));
      dispatch(setCMSUnitType({}));

      // await dispatch(
      //   getUnitConversionDetail({
      //     drugSeqNum: val.map((item) => {
      //       return item?.drugSeqNum;
      //     }),
      //   })
      // );
      if (val?.length < 1000)
        await dispatch(
          getNDCByMfgId(
            {
              showAllInd: false,
              drugSeqNum: val.map((item) => item?.drugSeqNum),
            },
            errorMessagesFromRedux
          )
        );
      else {
        setConfirmAction(true);
        setNdcList(val.map((item) => item?.drugSeqNum));
      }
    } else if (
      type === 'buttonclick' &&
      arr2.length > 0 &&
      state?.selectTypeCd === 'AN' &&
      state?.selectByCd === 'Mn'
    ) {
      dispatch(dispatchFirstTimeAdd(true));
      dispatch(dispatchStatusBit(1));
      dispatch(setCMSUnitType({}));
      await dispatch(
        getUnitConversionDetail({
          drugSeqNum: arr2,
        })
      );
    }
    if (type === 'ExtRow') {
      dispatch(dispatchStatusBit(1));
      dispatch(setCMSUnitType({}));
      await dispatch(
        getUnitConversionDetail({
          drugSeqNum: [val?.drugSeqNum],
        })
      );
    }
    if (
      state?.selectByCd === 'Mn' &&
      !state.allmanufacturercd &&
      type === 'mfgclick'
    ) {
      dispatch(dispatchStatusBit(1));
      dispatch(setCMSUnitType({}));
      await dispatch(
        getNDCByMfgId(
          {
            showAllInd: state.allmanufacturercd,
            mfgId: payLoad,
          },
          errorMessagesFromRedux
        )
      );
    }
    if (
      state?.selectByCd === 'Mn' &&
      state.allmanufacturercd &&
      type === 'buttonclick' &&
      state?.selectTypeCd === 'Ad'
    ) {
      dispatch(dispatchStatusBit(1));
      dispatch(setCMSUnitType({}));
      await dispatch(
        getNDCByMfgId(
          {
            showAllInd: state.allmanufacturercd,
            mfgId: payLoad,
          },
          errorMessagesFromRedux
        )
      );
    } else if (
      state?.selectByCd === 'Mn' &&
      !state.allmanufacturercd &&
      type === 'buttonclick' &&
      state?.selectTypeCd === 'Ad'
    ) {
      dispatch(dispatchStatusBit(1));
      dispatch(setCMSUnitType({}));
      await dispatch(
        getNDCByMfgId(
          {
            showAllInd: false,
            mfgId: selectManufacturer?.manufacturersId,
          },
          errorMessagesFromRedux
        )
      );
    }
  };

  const onSelectManufacturer = React.useCallback((e) => {
    setSelectManufacturer(e.data);
    dispatch(setMfgSelected(e.data));
  });

  return (
    <div
      className="tBillPanel custom-check tabs-container"
      data-testid="ProviderReview"
    >
      <CustomSeparator parent1="Maintain" parent2="Unit Conversion" />
      <DisplayErrorMessages
        errorMessages={[
          ...new Set(
            errorMessagesFromRedux?.searchScreenErrors?.length > 0
              ? _.map(
                  errorMessagesFromRedux?.searchScreenErrors,
                  (l) => l.message
                )
              : []
          ),
        ]}
      />
      <Spinner load={spinnerLoader} />
      <div className="no-margin">
        <div className="row">
          <legend aria-hidden="true" className="d-none" />

          <div className="col-12 col-xl-9 frr-radio-50per-width">
            <RadioGroupComponent
              data-testid="action-redio-btn"
              id="action-radio-btn-action"
              labelName="Selection"
              required
              reqColor
              optionList={[
                {
                  name: 'All Drugs with Zero Conversion Factors',
                  value: 'Ad',
                },
                {
                  name: 'Existing Rows',
                  value: 'ER',
                },
                {
                  name: 'Add a New NDC',
                  value: 'AN',
                },
              ]}
              defaultValue={
                getReduxValue?.state?.selectTypeCd || state?.selectTypeCd
              }
              filterAction={(e) => filterAction('selectTypeCd', e)}
              className="log-batch-filter-radio"
            />
          </div>
        </div>
        {getReduxValue?.state?.selectTypeCd === 'Ad' ? (
          <div className="row">
            <div className="col-12 col-sm-12 col-md-5 frr-radio-50per-width mt-3 mb-3">
              <RadioGroupComponent
                data-testid="action-redio-btn"
                id="action-radio-btn-action"
                labelName="Select By"
                optionList={[
                  {
                    name: 'Manufacturer',
                    value: 'Mn',
                  },
                  {
                    name: 'NDC',
                    value: 'NDC',
                  },
                ]}
                defaultValue={
                  getReduxValue?.state?.selectByCd || state?.selectByCd
                }
                filterAction={(e) => filterAction('selectByCd', e)}
                className="log-batch-filter-radio"
              />
            </div>
            {getReduxValue?.state?.selectByCd === 'Mn' ? (
              <div className="col-5 pr-0">
                <div className="d-flex flex-row mt-5">
                  <FormControlLabel
                    className="ml-0"
                    data-testid="checked_ia"
                    control={<Checkbox color="primary" className="mr-2" />}
                    label="All Manufacturers"
                    value={
                      getReduxValue?.state?.allmanufacturercd ||
                      state?.allmanufacturercd
                    }
                    checked={
                      getReduxValue?.state?.allmanufacturercd ||
                      state?.allmanufacturercd
                    }
                    onChange={(e) =>
                      filterAction('allmanufacturercd', e.target.checked)
                    }
                  />
                </div>
              </div>
            ) : (
              ''
            )}
          </div>
        ) : (
          ''
        )}
        {state?.selectTypeCd === 'ER' && (
          <div className="col-5 pr-0">
            <div className="d-flex flex-row frr-mt-37">
              <FormControlLabel
                className="ml-0"
                data-testid="checked_ia"
                control={<Checkbox color="primary" className="mr-2" />}
                label="Open Conversions Only"
                value={
                  getReduxValue?.state?.openConversionsCd ||
                  state?.openConversionsCd
                }
                checked={state?.openConversionsCd}
                onChange={(e) =>
                  filterAction('openConversionsCd', e.target.checked)
                }
              />
            </div>
          </div>
        )}
        {state?.selectTypeCd === 'Ad' ? (
          <div className="row">
            {state?.selectByCd !== 'NDC' && (
              <div className="col-12 mt-3">
                <div className="input-md frr-checkinvoice-search text-right">
                  <Button
                    className="btn btn-success btn-save btn-primary"
                    data-testid="provider-review-detail-history"
                    onClick={(e) => {
                      handleOnClick(e, 'buttonclick');
                      dispatch(dispatchBottonState(true));
                    }}
                    disabled={false}
                  >
                    <SVGComponent iconName="Icon-view" /> {'  '} View Unit
                    Conversion
                  </Button>
                </div>
              </div>
            )}
          </div>
        ) : (
          ''
        )}
        {state?.selectTypeCd === 'ER' ? (
          <div className="row">
            <div className="col-12 mt-3">
              <div className="input-md frr-checkinvoice-search text-right">
                <Button
                  className="btn btn-success btn-save btn-primary"
                  data-testid="provider-review-detail-history"
                  onClick={(e) => {
                    handleOnClick(e, 'buttonclick');
                    dispatch(dispatchBottonState(true));
                  }}
                  disabled={false}
                >
                  <SVGComponent iconName="Icon-view" /> {'  '} View Unit
                  Conversion
                </Button>
              </div>
            </div>
          </div>
        ) : (
          ''
        )}
        {state?.selectTypeCd === 'Ad' ? (
          <div className="row">
            {state?.selectByCd === 'NDC' ? (
              <div className="col-sm-12">
                <SearchTypeComponent
                  id="claimAuditSelect"
                  data-testid="claim-audit-select-Ndc-Component"
                  viewDetailButtonName="View Unit Conversion"
                  searchType={searchType}
                  setSearchType={setSearchType}
                  getErrorsFromSearchTypeComponent={
                    getErrorsFromSearchTypeComponent
                  }
                  errorMsgFromSearchType={errorMsgFromSearchType}
                  setLabelerFullScreen={setLabelerFullScreen}
                  labelerFullScreen={labelerFullScreen}
                  setNdcLeftFullScreen={setNdcLeftFullScreen}
                  ndcLeftFullScreen={ndcLeftFullScreen}
                  setNdcRightFullScreen={setNdcRightFullScreen}
                  ndcRightFullScreen={ndcRightFullScreen}
                  handleViewDetailFunction={(e) => {
                    handleOnClick(e, 'buttonclick');
                    dispatch(dispatchBottonState(true));
                  }}
                  setlabelerSelectedRow={setlabelerSelectedRow}
                  labelerSelectedRow={labelerSelectedRow}
                  setNdcLeftSelectedRows={setNdcLeftSelectedRows}
                  ndcLeftSelectedRows={ndcLeftSelectedRows}
                  setNdcRightSelectedRows={setNdcRightSelectedRows}
                  ndcRightSelectedRows={ndcRightSelectedRows}
                  setlabelerTableData={setlabelerTableData}
                  labelerTableData={labelerTableData}
                  setNdcLeftTableData={setNdcLeftTableData}
                  ndcLeftTableData={ndcLeftTableData}
                  setNdcRightTableData={setNdcRightTableData}
                  ndcRightTableData={ndcRightTableData}
                  setNdcSearchVal={setNdcSearchVal}
                  ndcSearchVal={ndcSearchVal}
                  setNdcNameSearchVal={setNdcNameSearchVal}
                  ndcNameSearchVal={ndcNameSearchVal}
                />

                <CommonModal
                  open={confirmAction}
                  viewAction
                  className="dialog-420"
                  viewHeader
                  onOk={async () => {
                    setConfirmAction(false);
                    await dispatch(
                      getNDCByMfgId(
                        {
                          showAllInd: false,
                          drugSeqNum: ndcList?.filter((val, ind) => ind < 1000),
                        },
                        errorMessagesFromRedux
                      )
                    );
                    setNdcList(null);
                  }}
                  okTitle="Ok"
                  closeTitle="Cancel"
                  onClose={() => setConfirmAction(false)}
                  modalTitle="Confirmation Dialog"
                  childrenComponent={constantMessageData.NDC_LIMIT_TO_1000}
                />
              </div>
            ) : (
              ''
            )}
          </div>
        ) : state?.selectTypeCd === 'ER' && getExistingRow ? (
          <div className="row">
            <div className="col-sm-12">
              <TableGridWithFeatures
                data-testid="manufacturer-cbi-table"
                rowSelection="multiple"
                rowMultiSelectWithClick={false}
                fullScreenView={fullScreenView}
                handleFullScreenViewClick={handleFullScreenView}
                gridCall={onGridReady1}
                gridHeight={fullScreenView ? '100vh' : 350}
                onSelectionChanged={onSelectionChanged}
                rowData={getExistingRow}
                columnDefs={NDCTableHead}
                cellClickedListener={(e) => {
                  handleOnClick(e.data, 'ExtRow');
                  dispatch(dispatchBottonState(true));
                }}
                exportFile
                fileName="unitConversion-existingRowlist"
                helpMessage="* On Double Click of Results, system should navigate to Detail page"
                animateRows
                sideBar={false}
                singleClickEdit
                enterMovesDown
                suppressCellFocus
                frameworkComponents={{
                  HyperLinkNameRender: (cellInfo) => {
                    let name = '';
                    if (cellInfo?.colDef?.headerName === 'NDC') {
                      name = cellInfo.data.ndc;
                    }

                    return <div>{name}</div>;
                  },
                }}
              />
            </div>
          </div>
        ) : (
          state?.selectTypeCd === 'AN' && <UnitConversion1st />
        )}

        {state?.selectByCd === 'Mn' &&
        !state?.allmanufacturercd &&
        state?.selectTypeCd !== 'ER' &&
        state?.selectTypeCd !== 'AN' &&
        getManufacturerTableData ? (
          <div className="row">
            <div className="col-sm-12">
              <TableGridWithFeatures
                data-testid="manufacturer-cbi-table"
                rowSelection="multiple"
                rowMultiSelectWithClick={false}
                fullScreenView={fullScreenView}
                handleFullScreenViewClick={handleFullScreenView}
                gridCall={onGridReady}
                gridHeight={fullScreenView ? '100vh' : 350}
                rowData={getManufacturerTableData || []}
                columnDefs={manufacturersTableHead}
                cellClickedListener={(e) => {
                  handleOnClick(e.data, 'mfgclick');
                  dispatch(dispatchBottonState(true));
                }}
                onSelect={(e) => {
                  onSelectManufacturer(e);
                }}
                exportFile
                tabToNextCell={tabToNextCell}
                fileName="unitConversion-MfgList"
                helpMessage="* On Double Click of Results, system should navigate to Detail page"
                animateRows
                navigateToNextCell={navigateToNextCell}
                sideBar={false}
                singleClickEdit
                enterMovesDown
                onCellFocused={onCellFocused}
                suppressCellFocus
              />
            </div>
          </div>
        ) : (
          ''
        )}
      </div>
    </div>
  );
};
export default UnitConversion;
